module.exports = __webpack_public_path__ + "static/media/p2008mot3.5e8f4bf0.jpg";